import { isEmpty, isNil } from 'ramda'

export const isValue = (value: any) => !isNil(value) && !isEmpty(value)
